export type MfaLevel = "aal1" | "aal2" | null;

export type AdminMfaDecisionInput = {
  mfaFeatureEnabled: boolean;
  hasVerifiedTotp: boolean;
  trustedDeviceValid: boolean;
  currentLevel: MfaLevel;
};

export function shouldRequireTotp(input: AdminMfaDecisionInput): boolean {
  if (!input.mfaFeatureEnabled) return false;
  if (!input.hasVerifiedTotp) return false;
  if (input.currentLevel === "aal2") return false;
  if (input.trustedDeviceValid) return false;
  return true;
}
